import api from '..';
import config from '../../config';

export const getStampCollection = (stampCollectionId, params, auth, setAuth) => {
  return api.get(`${config.snapPopPath}/stamp_collections/${stampCollectionId}`, params, auth, setAuth);
};

export const getStampCollections = (params, auth, setAuth) => {
  return api.get(`${config.snapPopPath}/stamp_collections`, params, auth, setAuth);
};

export const getUserStamps = (params, auth, setAuth) => {
  return api.get(`${config.snapPopPath}/user_stamps`, params, auth, setAuth);
};

export const addUserStamp = (stampId, auth, setAuth) => {
  const body = { stamp_template: stampId };
  return api.post(`${config.snapPopPath}/user_stamps`, body, auth, setAuth);
};
